import { AppShell } from "@/components/AppShell";
import { AreaCalculator } from "@/components/orders/AreaCalculator";
import { useLocale } from "@/lib/locale";

/** Standalone m² calculator for site visits: floor and wall side by side. */
export default function AreaCalculatorPage() {
  const { t } = useLocale();
  return (
    <AppShell>
      <div className="brand-kicker">{t.groupSales}</div>
      <h1 className="font-serif text-2xl text-paper sm:text-3xl">{t.areaCalc}</h1>
      <p className="mt-2 max-w-2xl text-sm text-ice/70">
        Measure in metres. Floor: add one rectangle per part of the room. Wall: length and width give the perimeter (or type it), times the height, minus doors and windows. Inside a quotation the same calculator sits under every Area field and fills it for you.
      </p>
      <div className="mt-4 grid gap-4 lg:grid-cols-2">
        <section className="glass-panel p-4">
          <AreaCalculator kind="floor" />
        </section>
        <section className="glass-panel p-4">
          <AreaCalculator kind="wall" />
        </section>
      </div>
    </AppShell>
  );
}
